<div fusePerfectScrollbar class="page-layout simple">
    <div class="content p-24">
        <div fxLayout="column" style="max-width: 810px;">
            <div class="row">

                <mat-card>
                    <mat-card-header style="height: 90px;">
                        <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
                            <div>Meus impressos</div>
                        </mat-card-title>
                        <mat-card-subtitle>
                            <small>* Atenção, os arquivos ficarão armazenados por 15 dias.</small>
                        </mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                            <!-- Position Column -->
                            <ng-container matColumnDef="id">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let element">
                                    <mat-icon>print</mat-icon>
                                </td>
                            </ng-container>

                            <!-- Position Column -->
                            <ng-container matColumnDef="jobTitle">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let element">
                                    <div class="text-max-400" title="{{element.jobTitle}}">{{element.jobTitle}}</div>
                                </td>
                            </ng-container>


                            <!-- Position Column -->
                            <ng-container matColumnDef="jobId">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let element">
                                    Arquivo {{element.id}}
                                </td>
                            </ng-container>


                            <!-- Name Column -->
                            <ng-container matColumnDef="createdAt">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let element">
                                    <div *ngIf="element.createdAt">
                                        {{element.createdAt | date: 'dd/MM/yyyy HH:mm - EEE'}}
                                    </div>
                                </td>
                            </ng-container>

                            <!-- Symbol Column -->
                            <ng-container matColumnDef="printId">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let element" class="text-align-center">
                                    <button type="button" mat-raised-button color="primary"
                                            (click)="openPDF(element.id)">Baixar
                                    </button>
                                </td>
                            </ng-container>

                            <tr mat-header-row class="display-none" *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                        <mat-paginator [pageSizeOptions]="[25, 50, 100]" [length]="totalPdfPrints"></mat-paginator>

                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
</div>